import { gettersBuilder } from '@/helpers/store';
import stateBasicKeys from './_basicKeys';
import requestStatusKeys from './_requestStatusKeys';

export default {
    ...gettersBuilder(stateBasicKeys),
    ...gettersBuilder(requestStatusKeys),
};
